import React, { FunctionComponent } from 'react';

import {SimpleSelect, IItem} from '../../select';
import {optionsShareResource} from '../../../models';

type OnChangeCallback = (value: any) => void;

interface SelectActionProps {
  selected?: string;
  disabled?: boolean;
  onChange?: OnChangeCallback;
  usePortal?: boolean;
  options?: IItem[];
}

const SelectAction: FunctionComponent<SelectActionProps> = ({
  selected,
  disabled,
  onChange,
  usePortal = false,
  options = undefined,
}: SelectActionProps) => {
  return (
    <SimpleSelect
      selected={selected}
      disabled={disabled}
      onChange={onChange}
      options={options || optionsShareResource as IItem[]}
      popoverProps={{usePortal: usePortal}}/>
  );
};

export default SelectAction;
